<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="contasreceber"
      :options.sync="opts"
      :server-items-length="total"
      @update:options="updateOptions"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [10, 50, 100, 200] }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('cliente.criar_contasreceber')"
            depressed
            color="accent"
            :to="{ name: 'cliente-formulario' }"
          >
            <v-icon class="mdi mdi-account-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id_empresa="{ item }">
        <span class="caption">{{ item.empresa.nome_fantasia }}</span>
      </template>
      <template v-slot:item.id_cliente="{ item }">
        <span class="caption">{{ strDocumento(item.clientes) }}</span>
        <BR />
        {{ item.clientes.nome }}
      </template>

      <template v-slot:item.data_vencimento="{ item }">
        <span class="caption">{{ dataBR(item.data_vencimento) }}</span>
      </template>

      <template v-slot:item.valor_receber="{ item }">
        <span class="caption">{{ number_format(item.valor_receber) }}</span>
      </template>

      <template v-slot:item.id_forma_pagamento="{ item }">
        <span class="caption">{{ item.forma_pagamento.descricao }}</span>
      </template>

      <template v-slot:item.situacao="{ item }">
        <span class="caption">{{ infoSituacao[item.situacao] }}</span>
      </template>

      <template v-slot:item.data_baixa="{ item }">
        <span class="caption">{{ dataBR(item.data_baixa) }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <dialog-confirm
          v-if="
            perms.includes('financeiro.baixar_contasreceber') &&
              item.situacao == 'AB'
          "
          titulo="Recebimento de contas a receber"
          texto="Confirma o recebimento do valor total dessa fatura?"
          @confirmar="liquidar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-cash-check" small />
          </v-btn>
        </dialog-confirm>

        <v-btn
          v-if="item.situacao == 'AB'"
          icon
          small
          @click="imprimirBoleto(item)"
        >
          <v-icon
            title="Fatura e boletos"
            class="mdi mdi-cash-usd-outline"
            small
          />
        </v-btn>

        <v-btn
          v-if="
            perms.includes('financeiro.editar_contasreceber') &&
              item.situacao == 'AB'
          "
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="
            perms.includes('financeiro.excluir_contasreceber') &&
              item.situacao == 'AB'
          "
          titulo="Deletar contas a receber"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
    <seletor-boleto />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import number_format_lib from "../lib/number_format";
import SeletorBoleto from "../components/boletos/SeletorBoletoContasReceber";
import { build } from "../lib/masks";
export default {
  components: {
    DatatableFilters,
    DialogConfirm,
    SeletorBoleto
  },
  data() {
    return {
      headers: [
        { text: "Empresa", value: "id_empresa" },
        { text: "Cliente", value: "id_cliente" },
        { text: "Fatura", value: "documento" },
        {
          text: "OM",
          value: "origem_object.id_ordem",
          align: "center",
          sortable: false
        },
        { text: "Data Vencimento", value: "data_vencimento" },
        { text: "Valor (R$)", value: "valor_receber" },
        { text: "Forma Pagamento", value: "id_forma_pagamento" },
        {
          text: "Situação",
          value: "situacao",
          sortable: false,
          align: "center"
        },
        { text: "Data Baixa", value: "data_baixa" },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "documento",
          label: "Fatura/NF",
          type: "text"
        },
        {
          name: "id_empresa",
          label: "Empresa",
          type: "select",
          options: []
        },
        {
          name: "id_cliente",
          label: "Cliente",
          type: "select",
          multiple: false,
          options: []
        },
        {
          name: "id_vendedor",
          label: "Vendedor",
          type: "select",
          multiple: false,
          options: []
        },
        {
          name: "situacao",
          label: "Situação",
          type: "select",
          multiple: false,
          options: [
            {
              value: "DG",
              text: "Digitação"
            },
            {
              value: "AB",
              text: "Aberto"
            },
            { value: "PG", text: "Pago" },
            {
              value: "CA",
              text: "Cancelado"
            }
          ]
        },
        {
          name: "id_forma_pagamento",
          label: "Forma de pagamento",
          type: "select",
          multiple: false,
          options: []
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.contasreceber") || `{}`
      ),
      loading: true,
      menu: [],
      infoSituacao: {
        DG: "Digitação",
        AB: "Aberto",
        PG: "Pago",
        CA: "Cancelado"
      },
      opts: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["data_vencimento"],
        sortDesc: ["desc"]
      }
    };
  },
  computed: mapState({
    contasreceber: state => state.contasReceber.contasReceber.dados,
    total: state => state.contasReceber.contasReceber.total,
    perms: state => state.usuarios.usuarioAtivo.permissoes
  }),
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("contasReceber/deletar", id);
      this.listar(this.opts);
    },
    editar(id) {
      this.$router.replace({
        name: "contas-receber-editar",
        params: { id }
      });
    },
    async listar(options) {
      this.loading = true;
      try {
        let ordenacao = options.sortBy[0];
        if (options.sortDesc[0]) {
          ordenacao += " desc";
        }

        await this.$store.dispatch("contasReceber/listar", {
          filtros: this.filtrosAtivos,
          CarregarOrigem: true,
          pagina: options.page,
          por_pagina: options.itemsPerPage,
          ordenacao
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de clientees"
        });
      }
      this.loading = false;
    },
    strDocumento(cliente) {
      try {
        if (cliente.tipo === "F") {
          return build.cpf(cliente.cpf_cnpj);
        } else {
          return build.cnpj(cliente.cpf_cnpj);
        }
      } catch (err) {
        console.log(cliente);
        return "*Cliente Excluído*";
      }
    },
    dataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.substr(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    number_format(numero) {
      return number_format_lib(numero);
    },
    async liquidar(id) {
      await this.$store.dispatch("contasReceber/gravar", {
        id: id,
        situacao: "PG",
        data_baixa: new Date()
      });

      this.listar(this.opts);
    },
    async imprimirBoleto(cr) {
      this.$store.commit("boleto/setOrdemAtivaSeletor", cr);
    },
    updateOptions(opts) {
      this.listar(opts);
    }
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.contasreceber", JSON.stringify(val));
      this.opts.page = 1;
      this.listar(this.opts);
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Contas a receber"
    });

    this.$store.dispatch("empresa/listar", {}).then(empresas => {
      this.filters.find(
        f => f.name === "id_empresa"
      ).options = empresas.data.map(e => ({
        text: e.nome_fantasia,
        value: e.id
      }));
    });

    this.$store.dispatch("cliente/listar", {}).then(formas => {
      this.filters.find(
        f => f.name === "id_cliente"
      ).options = formas.data.clientes.map(f => ({
        text: `${f.nome} - ${f.razao_social}`,
        value: f.id
      }));
    });

    this.$store.dispatch("vendedor/listar", {}).then(vendedores => {
      this.filters.find(f => f.name === "id_vendedor").options = vendedores.map(
        v => ({
          text: `${v.id} - ${v.nome}`,
          value: v.id
        })
      );
    });

    this.$store.dispatch("formaPgto/listar", {}).then(formas => {
      this.filters.find(
        f => f.name === "id_forma_pagamento"
      ).options = formas.data.map(f => ({
        text: f.descricao,
        value: f.id
      }));
    });
  }
};
</script>
